import { DOCUMENT, inject, Injectable, InjectionToken } from '@angular/core';
import { forgetDemo, TabStorage, tabStorage } from './demo-mode';

/** Ce que la sortie de la démonstration fait de l'onglet. */
export interface DemoTab {
  storage: TabStorage | null;
  close(): void;
  isClosed(): boolean;
  /** Un chargement complet, et non une navigation du routeur. */
  load(url: string): void;
}

export const DEMO_TAB = new InjectionToken<DemoTab>('DEMO_TAB', {
  providedIn: 'root',
  factory: () => {
    const window = inject(DOCUMENT).defaultView!;
    return {
      storage: tabStorage(),
      close: () => window.close(),
      isClosed: () => window.closed,
      load: (url) => window.location.assign(url),
    };
  },
});

/** Le temps laissé au navigateur pour fermer l'onglet, avant de le ramener à l'application. */
const CLOSING_DELAY_MS = 300;

/** L'écran de l'application ordinaire où revient un onglet qui ne se ferme pas. */
const ORDINARY_START = '/contrats';

/**
 * « Quitter la démonstration » (RG-parcours-donnees-fictives) : l'onglet l'oublie, puis se ferme
 * quand l'application l'a ouvert. Le navigateur refuse de fermer un onglet que l'utilisateur a
 * ouvert lui-même — une adresse `/decouverte/…` collée — : celui-là revient à la liste des
 * contrats par un chargement complet, qui redémarre l'application hors démonstration, sans le
 * fichier de démonstration ni les données fictives en mémoire.
 */
@Injectable({ providedIn: 'root' })
export class DemoExit {
  private readonly tab = inject(DEMO_TAB);

  leave(): void {
    forgetDemo(this.tab.storage);
    this.tab.close();
    setTimeout(() => {
      if (!this.tab.isClosed()) this.tab.load(ORDINARY_START);
    }, CLOSING_DELAY_MS);
  }
}
